var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeerbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "820.000000pt",
    height: "112.000000pt",
    viewBox: "0 0 820.000000 112.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,112.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 785 l0 -335 450 0 450 0 0 -115 0 -115 -450 0 -450 0 0 -84 c0 -68 4 -88 19 -107 l19 -24 536 -3 536 -3 0 336 0 335 -445 0 -445 0 0 115 0 115 428 0 c403 0 430 1 445 18 13 15 17 39 17 110 l0 92 -555 0 -555 0 0 -335z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 1010 l0 -110 555 0 555 0 0 110 0 110 -555 0 -555 0 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 1010 l0 -110 555 0 555 0 0 110 0 110 -555 0 -555 0 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4027 1113 c-4 -3 -7 -53 -7 -110 l0 -103 450 0 450 0 0 -115 0 -115 -450 0 -450 0 2 -332 3 -333 60 -3 c33 -2 74 -1 92 3 62 11 63 15 63 241 l0 204 118 -1 117 -1 175 -201 c121 -139 187 -208 214 -221 28 -14 69 -20 154 -24 l116 -5 -20 26 c-10 14 -99 116 -197 226 l-178 201 201 0 200 0 -2 333 -3 332 -551 3 c-303 1 -554 -1 -557 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5370 560 l0 -560 505 0 c565 0 563 0 590 64 11 26 15 79 15 208 l0 172 -57 58 -57 58 57 58 57 58 -2 219 -3 220 -552 3 -553 2 0 -560z m890 225 l0 -115 -340 0 -340 0 0 115 0 115 340 0 340 0 0 -115z m0 -450 l0 -115 -340 0 -340 0 0 115 0 115 340 0 340 0 0 -115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6710 592 c0 -587 -3 -562 68 -582 20 -5 61 -10 90 -10 l52 0 0 560 0 560 -105 0 -105 0 0 -528z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7080 1010 l0 -110 220 0 220 0 0 -392 c0 -242 4 -407 11 -431 14 -51 46 -69 135 -75 l74 -5 0 452 0 451 225 0 225 0 0 110 0 110 -555 0 -555 0 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 448 c1 -123 4 -274 6 -336 l3 -113 534 3 c497 3 536 4 552 21 14 14 19 38 21 107 l4 90 -451 0 -451 0 0 115 0 115 445 0 445 0 0 110 0 110 -555 0 -556 0 3 -222z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 568 c0 -57 3 -208 7 -336 l6 -233 533 3 c496 3 535 4 551 21 14 14 19 38 21 107 l4 90 -451 0 -451 0 0 115 0 115 445 0 445 0 0 110 0 110 -555 0 -555 0 0 -102z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeerbit);
export default __webpack_public_path__ + "static/media/seerbit.02f0c689f5aa9cd54cac85b99d79753e.svg";
export { ForwardRef as ReactComponent };